module.exports = __webpack_public_path__ + "6232f43d15b0e7a0bf0fe82e295bdd06.woff2";